import PropTypes from 'prop-types';
import { jsx as _jsx } from "react/jsx-runtime";
const baseNopeZoneStyles = {
  position: 'absolute',
  zIndex: 1,
  backgroundColor: '#99acc2',
  opacity: 0.5
};
const computeNopeZoneStyles = (top, left, right, bottom) => {
  return {
    left: `${left}px`,
    top: `${top}px`,
    width: `${right - left}px`,
    height: `${bottom - top}px`
  };
};
function NopeZone({
  top,
  left,
  right,
  bottom,
  backgroundColor = baseNopeZoneStyles.backgroundColor,
  opacity = baseNopeZoneStyles.opacity,
  cursor = baseNopeZoneStyles.cursor
}) {
  // Not using useMapTokenPropsToCSS since these can't be tokenized since they're
  // displayed over user content
  const cssStyles = {
    backgroundColor,
    opacity,
    cursor
  };
  const style = Object.assign({}, baseNopeZoneStyles, computeNopeZoneStyles(top, left, right, bottom), cssStyles);
  return (
    /*#__PURE__*/
    // Explicitly not using styled components to avoid namespacing, which
    // prevents this edge case:
    // https://git.hubteam.com/HubSpot/ContentEditorUI/pull/13640
    // @bend-expect trellis-tokenized
    _jsx("div", {
      style: style
    })
  );
}
NopeZone.propTypes = {
  top: PropTypes.number.isRequired,
  left: PropTypes.number.isRequired,
  right: PropTypes.number.isRequired,
  bottom: PropTypes.number.isRequired
};
export default NopeZone;